import * as React from "react";
import { Trans } from "react-i18next";
import {
  BalanceUpdateScheduledAwardDetailsFragmentFragment,
} from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";

export const BalanceUpdateScheduledAwardDetails = ({
  details,
}: {
  details: BalanceUpdateScheduledAwardDetailsFragmentFragment;
}) => {
  return (
    <div>
      <Trans
        className="flex"
        i18nKey="notification.balance_update_scheduled_tournament"
        components={{ name: <span className="font-bold" /> }}
        values={{
          scheduledTournamentName: details.tournamentName || ""
        }}
      />
    </div>
  );
};
